// extracted by mini-css-extract-plugin
export default {"wrapper":"T3WaqrTGJ7lw5qzs39gK"};